import { computed } from "vue";
import { p as pick_1 } from "../../vendor-b303cd6e.mjs";
import { u as useBem } from "./useBem-a19cd502.mjs";
const useFormFieldProps = {
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false }
};
const useFormField = (prefix, props) => {
  const computedClasses = useBem(prefix, computed(() => pick_1(props, ["disabled", "readonly"])));
  return { computedClasses };
};
export {
  useFormField as a,
  useFormFieldProps as u
};
//# sourceMappingURL=useFormField-fc3f10c4.mjs.map
